export const environment = {
  production: true,
  API_BASE_PATH: 'https://api.cykelmakker.dk',
  S3_BASE_PATH: 'https://s3-eu-west-1.amazonaws.com/rma.trafficbeam/',
  GOOGLE_API: 'AIzaSyCZr9UnQrA-gb-3OEUG4A67YK1Sfyvz6kk',
  firebase: {
    apiKey: 'AIzaSyDv7w_HzLsIikgYqHF1taeaqF8aattCD-A',
    authDomain: 'bikerep-219816.firebaseapp.com',
    databaseURL: 'https://bikerep-219816.firebaseio.com',
    projectId: 'bikerep-219816',
    storageBucket: 'bikerep-219816.appspot.com',
    messagingSenderId: '612190789698'
  }
};
